// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdSearch } from 'react-icons/lib/md';

import * as selectors from '../../reducers';
import Typeahead from '../Typeahead/async';
import OmnisearchResult from '../OmnisearchResult';
import { generateFetcher } from '../Omnisearch/utils';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';


export const ROUTE_SEARCH_RESULT_TYPES = {
  route: 'route',
};

type SingleTypeSearchPropTypes = {
  fetchItems: string => Promise<Array<Object>>,
  onChange: Object => mixed,
  searchResultType: string,
  className?: string,
  placeholder?: string,
  inputProps?: Object,
};


class SingleTypeSearch extends React.Component<SingleTypeSearchPropTypes> {
  getInput() {
    return this._typeahead ? this._typeahead.getInput() : null;
  }

  _typeahead: ?Typeahead;

  render() {
    const {
      fetchItems,
      onChange,
      className,
      placeholder,
      inputProps = {},
      ...rest
    } = this.props;

    return (
      <Typeahead
        {...rest}
        className={className}
        inputDebounce={500}
        renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
        inputProps={{
          Icon: MdSearch,
          iconPosition: 'right',
          placeholder,
          ...inputProps,
        }}
        clearAfterSelected
        onChange={onChange}
        renderItem={
          (item, isHighlighted) => (
            <OmnisearchResult
              {...item}
              key={item.value}
              isSelected={isHighlighted}
              size="small"
            />
          )
        }
        fetchItems={fetchItems}
        value={undefined}
        ref={(node) => { this._typeahead = node; }}
      />
    );
  }
}

export default connect(
  (state, { searchResultType }) => {
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const token = selectors.getToken(state);

    return {
      // school: (selectors.getProfileOfType(state, 'admin') || {}).school,
      fetchItems: generateFetcher(
        searchResultType,
        schoolId,
        token,
      ),
    };
  },
  undefined,
  undefined,
  { withRef: true },
)(SingleTypeSearch);



// WEBPACK FOOTER //
// ./src/scripts/components/SingleTypeSearch/index.jsx